import { connect, ConnectedProps } from 'react-redux';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import McpSettings from './mcp-settings';
import { RootState } from '../../../../store/root-reducer';
import {
  resetRevokeMcpSessionRequest,
  resetCreateMcpApiKeyRequest,
} from './mcp-settings-slice';
import {
  getMcpSessionsRequest,
  revokeMcpSessionRequest,
  createMcpApiKeyRequest,
  fetchMcpApiKeyRequest,
} from './extra-actions';

const mapStateToProps = (state: RootState) => ({
  sessions: state.mcpSettings.sessions,

  getMcpSessionsRequestStatus: state.mcpSettings.getMcpSessionsRequest.status,
  getMcpSessionsRequestError: state.mcpSettings.getMcpSessionsRequest.error,

  revokeMcpSessionRequestStatus:
    state.mcpSettings.revokeMcpSessionRequest.status,
  revokeMcpSessionRequestError: state.mcpSettings.revokeMcpSessionRequest.error,

  generatedApiToken: state.mcpSettings.generatedApiToken,
  createMcpApiKeyRequestStatus:
    state.mcpSettings.createMcpApiKeyRequest.status,
  mcpApiKeyExists: state.mcpSettings.mcpApiKeyExists,

  isLoading: state.mcpSettings.isLoading,
});

const mapDispatchToProps = {
  sendGetMcpSessionsRequest: () => getMcpSessionsRequest(),
  sendRevokeMcpSessionRequest: (args: { sessionId: number }) =>
    revokeMcpSessionRequest(args),
  resetRevokeMcpSessionRequest: () => resetRevokeMcpSessionRequest(),
  sendCreateMcpApiKeyRequest: () => createMcpApiKeyRequest(),
  sendFetchMcpApiKeyRequest: () => fetchMcpApiKeyRequest(),
  resetCreateMcpApiKeyRequest: () => resetCreateMcpApiKeyRequest(),
  showLoading: () => showLoading(),
  hideLoading: () => hideLoading(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(McpSettings);
